const calculatePortfolioYield = (portfolio, availableAssets) => {
    let totalValue = 0
    let weightedYield = 0
  
    for (const asset of portfolio) {
      const stockData = availableAssets.find(a => a.symbol === asset.symbol)
      if (!stockData) continue
  
      const value = asset.amount * stockData.price
      totalValue += value
      weightedYield += value * (stockData.yield / 100)
    }
  
    return totalValue > 0 ? weightedYield / totalValue : 0
  }
  
  const calculateEndOfYearValue = (portfolio, availableAssets) => {
    let totalInvestment = 0
    let annualDividend = 0
  
    for (const asset of portfolio) {
      const stockData = availableAssets.find(a => a.symbol === asset.symbol)
      if (!stockData) continue
  
      const investment = asset.amount * stockData.price
      totalInvestment += investment
      annualDividend += investment * (stockData.yield / 100)
    }
  
    return {
      totalInvestment,
      annualDividend,
      endOfYearValue: totalInvestment + annualDividend
    }
  }
  
  const calculateSamplePortfolio = (stocks, costPerStock) => {
    let totalInvestment = 0
    let annualDividend = 0
  
    for (const stock of stocks) {
      const investment = 5 * costPerStock
      totalInvestment += investment
      annualDividend += investment * (stock.yield / 100)
    }
  
    return {
      totalInvestment,
      annualDividend,
      endOfYearValue: totalInvestment + annualDividend
    }
  }
  
  export { calculatePortfolioYield, calculateEndOfYearValue, calculateSamplePortfolio }